import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  TemplateRef,
  OnInit,
  AfterViewInit,
  OnDestroy,
  NgZone } from '@angular/core';
import {
  startOfDay,
  format,
  endOfMonth,
  startOfMonth,
  addMonths,
  subMonths } from 'date-fns';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarEvent,
  CalendarMonthViewDay } from 'angular-calendar';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';

import { DateModel, DateStoreModel } from './date.model';

import { State } from '../../reducers/index';
import { SHOW_HEADER, OVERLAY_START } from '../../actions/header.action';
import { Info, INFO_UPDATE } from '../../actions/info.action';
import { Booking } from '../../actions/booking.action';
import { DATA_REQUEST } from '../../actions/data.action';

@Component({
  selector: 'consentz-date',
  templateUrl: './date.template.html',
  styleUrls: ['./date.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateComponent implements OnInit, OnDestroy, AfterViewInit {
 public selectedValue = 'All';
 public locationsOpened: boolean = false;
 public newArray: any;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;

  public model: DateModel = new DateModel(
    JSON.parse(localStorage.getItem('currentBookingOptions')),
    localStorage.getItem('AppId') ? localStorage.getItem('AppId') : window.location.hash.split('/')[1]
  );
  public storeData: DateStoreModel = new DateStoreModel();
  private calendarCounter: number = 0;

  constructor(
    private modal: NgbModal,
    private cdr: ChangeDetectorRef,
    private store: Store<State>,
    private zone: NgZone
  ) {
    // hide header, allow ovelay, get date and practitioner worktime for week request
    this.store.dispatch({ type: SHOW_HEADER });
    this.store.dispatch({ type: OVERLAY_START });
    this.store.dispatch({
      type: DATA_REQUEST,
      payload: {
        requestUrl: `/online-booking/${localStorage.getItem('practitionerId')}/week`
      }
    });
    this.requestOnCalendar();
    // subscribtion on widget options, local selections
    this.storeData.subscribtion.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
    });
    this.storeData.subscribtion.info$ = store.select<any>('info').subscribe((data: Info) => {
      if (data['date']) {
        // console.log(11, this.model.calendarOptions);
        this.model.calendarOptions.selectedMonthViewDay.date = new Date(data['date']);
      }
    });
    this.model.goTreatment = !!localStorage.getItem('goToTreatment');
    this.model.locations = JSON.parse(localStorage.getItem('locations'));
    this.model.locations.unshift('All');
  }

  public selectLocation(event: any, location: string): void {
    event.stopPropagation();
    this.selectedValue = location;
    this.filterByLocation();
  }

  public filterByLocation(): void {
    if (this.selectedValue !== 'All') {
      this.newArray = [...this.model.calendarOptions.events.filter(event => event.location === this.selectedValue)];
      this.update();
      return;
    }
    this.newArray = [...this.model.calendarOptions.events];
    this.update();
  }
  // show all locations
  toggleLocations(): void {
    this.locationsOpened = !this.locationsOpened;
    this.update();
  }
  // add to store day
  public dayClicked(date: any, events: any): void {
    if (startOfDay(new Date()).getTime() <= date.date.getTime() && events.day.events.length !== 0) {
      this.newArray = [];
      localStorage.setItem('day', JSON.stringify(date.date));
      this.store.dispatch({
        type: DATA_REQUEST,
        payload: {
          requestUrl: `/online-booking/${localStorage.getItem('practitionerId')}/day/${['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][new Date(date.date).getDay()]}`
        }
      });
      this.store.dispatch({
        type: INFO_UPDATE,
        payload: {
          date: date.date
        }
      });
      if (this.model.calendarOptions.selectedMonthViewDay) {
        delete this.model.calendarOptions.selectedMonthViewDay.cssClass;
      }
      const e: any = event;
      if (!e.currentTarget.classList.contains('cal-out-month')) {
        events.day.cssClass = 'cal-day-selected';
        this.model.calendarOptions.selectedMonthViewDay = events.day;
      }
    }
  }
  // set to view selected date
  public beforeMonthViewRender({ body }: { body: CalendarMonthViewDay[] }): void {
    body.forEach(day => {
      if (
        this.model.calendarOptions.selectedMonthViewDay.date &&
        day.date &&
        day.date.getTime() === this.model.calendarOptions.selectedMonthViewDay.date.getTime()
      ) {
        day.cssClass = 'cal-day-selected';
        this.model.calendarOptions.selectedMonthViewDay = day;
      }
    });
  }
  // set events to calendar
  public ngAfterViewInit(): void {
    this.storeData.subscribtion.data$ = this.store.select<any>('data').subscribe((data: Info) => {

      this.model.calendarOptions.events = [];
      if (this.model.calendarOptions.events !== data) {
        // console.log(11, data['date']);
        data['date'].forEach(element => {
          this.addEvent({
            color: element.color,
            start: element.start,
            title: element.title,
            location: element.location
          });
        });
      }
      this.cdr.markForCheck();
      this.filterByLocation();
    });
  }
  // detect changes
  public updateCalendar(mode: string): any {
    clearTimeout(this.model.timeoutDebounce);
    this.model.timeoutDebounce = setTimeout(() => {
      mode ? this.calendarCounter++ : this.calendarCounter--;
      this.update();
      this.model.defaultDateValue = mode ? addMonths(this.model.defaultDateValue, 1) : subMonths(this.model.defaultDateValue, 1);
      this.requestOnCalendar();
    }, 300);
  }
  // detect changes
  public update(): void {
    this.model.changeDetectorRefTimeout = setTimeout(() => {
      this.cdr.reattach();
      this.cdr.detectChanges();
      this.cdr.detach();
    });
  }
  // set event to calendar
  public addEvent(date: any): void {
    this.model.calendarOptions.events.push(<CalendarEvent>{
      start: date.start,
      color: date.color,
      title: date.title,
      location: date.location
    });
  }
  // detect window size
  public sizeOfScreen(): number {
    return window.innerHeight;
  }
  // detach changes
  public ngOnInit(): void {
    this.cdr.detach();
  }
  // unsubscribe from store, clear changeDetectorRef timeout, detach changes
  public ngOnDestroy(): void {
    clearTimeout(this.model.changeDetectorRefTimeout);
    clearTimeout(this.model.timeoutDebounce);
    this.storeData.subscribtion.booking$.unsubscribe();
    this.storeData.subscribtion.data$.unsubscribe();
    this.storeData.subscribtion.info$.unsubscribe();
    this.cdr.detach();
  }
  // calendar events reqest
  private requestOnCalendar(): void {
    localStorage.setItem('defaultDateValue', this.model.defaultDateValue.toISOString());
    this.store.dispatch({
      type: DATA_REQUEST,
      payload: {
        requestUrl: `/online-booking/${localStorage.getItem('practitionerId')}/calendar?start=${format(startOfMonth(subMonths(this.model.defaultDateValue, 1)), 'YYYY-MM-DD')}&end=${format(endOfMonth(addMonths(this.model.defaultDateValue, 2)), 'YYYY-MM-DD')}`
      }
    });
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/date/date.component.ts